(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/game-limits-deposits-form/assets/service/max-limits-service.js') >= 0) return;  svs.modules.push('/components/accountservices-react/game-limits-deposits-form/assets/service/max-limits-service.js');
'use strict';

const isServer = typeof exports === 'object';
let jupiterHelper;
if (isServer) {
  const trinidad = require('@svenskaspelab/trinidad-core').core;
  jupiterHelper = trinidad.components.require('tb-utils', 'jupiter-helper').jupiterHelper;
} else {
  jupiterHelper = svs.components.tbUtils.jupiterHelper;
}

const getGamblingCareSpendLimitInfoAsync = async req => {
  const options = {
    method: 'GET',
    path: '/gamblingcare/1/spendlimit/info',
    req
  };
  const {
    data,
    error
  } = await jupiterHelper.streamlinedJupiterCall(options);
  return {
    data: (data === null || data === void 0 ? void 0 : data.response) || {},
    error
  };
};
const exportedFunctions = {
  getGamblingCareSpendLimitInfoAsync
};

if (isServer) {
  module.exports = exportedFunctions;
} else {
  svs.accountservicesReact.gameLimitDepositsForm.maxLimitsService = exportedFunctions;
}

 })(window);